import { LogaProxy } from "@app/models";
import moment from "moment";

export class DailyWorkerScheduleTemplateSlot {
    /**id in database**/
    id: number;

    /**index to tell if this is the first, second... slot of the day**/
    slotIndex: number;

    /**Hour of start, as simple int, should be between 0 and 23**/
    startH: number;

    /**Minute of start, as simple int, should be between 0 and 59**/
    startM: number;

    /**duration of the slot in minutes**/
    duration: number;

    /**id of the template it belongs to**/
    template: number;

    uiTemplate: LogaProxy;

    uiTemplateName: string;
    uiHrDuration: string;

    static FromJson(as: DailyWorkerScheduleTemplateSlot): DailyWorkerScheduleTemplateSlot {  
        let aa = new DailyWorkerScheduleTemplateSlot();
        if(as != null){
            aa.id = as.id;
            aa.slotIndex = as.slotIndex;
            aa.startH = as.startH;
            aa.startM = as.startM;
            aa.duration = as.duration;
            aa.template = as.template;
            aa.uiTemplate = as.uiTemplate;
        }
        return aa;
    }
}

export class SlotsForStoreReportSlot {
    id: number;
    day: number;
    resourceLane: number;
    resourcePool: string;
    indexInDay: number;
    operation: LogaProxy;
    assignedScheduleSlot: DailyWorkerScheduleTemplateSlot;
    activity: number;
    displayName: string;

    openForPlanning: boolean;
    plannedStoreName: null;

    suggestedTypeOfWorker: string;


    static FromJson(s: SlotsForStoreReportSlot): SlotsForStoreReportSlot {        
        let slot = new SlotsForStoreReportSlot();
        if (s != null){
            slot.id = s.id;
            slot.day = s.day;
            slot.resourceLane = s.resourceLane;
            slot.resourcePool = s.resourcePool;
            slot.indexInDay = s.indexInDay;
            slot.operation = s.operation;
            slot.assignedScheduleSlot = DailyWorkerScheduleTemplateSlot.FromJson(s.assignedScheduleSlot);
            slot.activity = s.activity;
            slot.displayName = s.displayName;
            slot.openForPlanning = s.openForPlanning;
            slot.plannedStoreName = s.plannedStoreName;
            slot.suggestedTypeOfWorker = s.suggestedTypeOfWorker;
        }
        return slot;
    }
}

export class SlotsForStoreReport {
    slots: SlotsForStoreReportSlot[] = [];

    /**
     * builder form JSON to get "instances"
     * @param oo
     */
    static FromJson(oo: SlotsForStoreReport) {
        let r: SlotsForStoreReport = new SlotsForStoreReport();
        r.slots = [];

        if (oo.slots != null){
            oo.slots.forEach(s => {
              r.slots.push(SlotsForStoreReportSlot.FromJson(s))
            })
        }
        return r;
    }
}


/**
 *  -- TEMPLATES
 **/

export class DailyWorkerScheduleTemplate {
    id: number;
    name: string;
    code: string;
    slots: DailyWorkerScheduleTemplateSlot[] = [];

    static FromJson(oo: DailyWorkerScheduleTemplate): DailyWorkerScheduleTemplate {
        let t: DailyWorkerScheduleTemplate = new DailyWorkerScheduleTemplate();
        t.id = oo.id;
        t.name = oo.name;
        t.code = oo.code;
        t.slots = [];
        if (oo.slots != null){
            oo.slots.forEach(sl => {
                let ssl = DailyWorkerScheduleTemplateSlot.FromJson(sl);
                ssl.uiTemplateName = t.name;
                ssl.uiHrDuration = moment.duration(ssl.duration, "minutes").toISOString();
                t.slots.push(ssl);
            });
        }
        return t;
    }
}

export class OperationDailyWorkerSchedulingOptions {
    operation: number;
    templates: DailyWorkerScheduleTemplate[] = [];

    static FromJson(oo: OperationDailyWorkerSchedulingOptions): OperationDailyWorkerSchedulingOptions {
        let t: OperationDailyWorkerSchedulingOptions = new OperationDailyWorkerSchedulingOptions();
        t.operation = oo.operation;
        t.templates = [];
        if (oo.templates != null){
            oo.templates.forEach(e => {
                t.templates.push(DailyWorkerScheduleTemplate.FromJson(e));
            });
        }
        return t;
    }
}

/**
 * Reporting & Slot Planning Progress
 **/

export class SlotPoolAsssignmentReport {
    resourcePool: string;
    totalNumberOfSlots: number;
    numberOfPlannedSlots: number;
}

export class SlotAssignReportRange {
    rangeName: string;
    poolSlotReports: SlotPoolAsssignmentReport[] = [];
    uiIsVisible: boolean;
}

export class SlotAssignmentPerPoolReport {
    rangeReports: SlotAssignReportRange[] = [];

    static FromJson(e: SlotAssignmentPerPoolReport) {
          return e;
    }
}
